/*
 * Copyright (C) 2025 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  Component, OnInit, Inject,
} from '@angular/core';

@Component({
  selector: 'ut-leaderboard',
  templateUrl: './leaderboard.component.html',
  standalone: false,
})
export class LeaderboardComponent implements OnInit {
  recent: any;
  allTime: any;
  activeTab = 'recent';

  constructor(
    @Inject('LeaderboardService') private LeaderboardService: any,
    @Inject('FeedStore') private FeedStore: any,
  ) {}

  ngOnInit(): void {
    // Create FeedStore instances for recent (30 days) and all time leaderboards
    this.recent = this.FeedStore.create(
      this.LeaderboardService.feed.bind(this.LeaderboardService),
      { days: 30, per_page: 20 },
    );
    this.allTime = this.FeedStore.create(
      this.LeaderboardService.feed.bind(this.LeaderboardService),
      { per_page: 20 },
    );

    // Load the recent leaderboard on initialization
    this.recent.load();
  }

  onTabChange(tabId: string): void {
    this.activeTab = tabId;
    // Load all time leaderboard when switching to that tab
    if (tabId === 'allTime') {
      this.allTime.loadOnce();
    }
  }
}
